import React, { Component } from 'react';
import { MapContainer as Map, Marker, Popup, TileLayer } from 'react-leaflet';

import { name_to_offsets } from '../utils'


import { SquadraInSessione as Squadra, SquadraTabella, City } from '../api/types';
import { ENTERPRISE } from '../globals';



type get_coord = (s: Squadra) => [number, number];
const get_city: (s: Squadra) => City | undefined = s => s.scuola.indirizzo?.citta


const get_coords: get_coord = s => {
  const [off_lat, off_lon] = name_to_offsets(s.nome);
  const indirizzo = s.scuola.indirizzo;
  if (!!indirizzo && !!indirizzo.latitude && !!indirizzo.longitude) {
    return [parseFloat(indirizzo.latitude) + off_lat, parseFloat(indirizzo.longitude) + off_lon]
  }
  const c = get_city(s);
  if (!!c && !!c.latitude && !!c.longitude) {
    return [parseFloat(c.latitude) + off_lat, parseFloat(c.longitude) + off_lon];
  }
  return ENTERPRISE;
}


interface IProps {
  punteggi: SquadraTabella[]
  nomi: { [squadra: string]: string; },
  squadre: Squadra[]
}


const MappaLeaflet = (props: IProps) => {
  const { punteggi } = props;
  const dati = punteggi.map(item => {
    const squadra = props.squadre.filter(sq => !!sq.scuola.indirizzo).find(i => i.nome == item.nome)
    const coords = squadra ? get_coords(squadra) : ENTERPRISE;
    return {
      nome: props.nomi[item.nome],
      punti: item.totale,
      coords: coords,
    }
  })
  return (
    <div className="overflow-auto">
      <Map center={ENTERPRISE} zoom={7} style={{ minHeight: '1300px', minWidth: '600px' }}>
        <TileLayer
          url="https://{s}.tile.osm.org/{z}/{x}/{y}.png"
          attribution="&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
        />
        {dati.map(item =>
          <Marker position={item.coords} key={item.nome}>
            <Popup>{item.nome}<br />Punteggio: {item.punti}</Popup>
          </Marker>
        )}
      </Map>
    </div>
  )
}

export default MappaLeaflet
